import React from "react";
import AntdAnchor, {AnchorProps} from "antd/lib/anchor";
import AnchorLink from "antd/lib/anchor/AnchorLink";

import {withError} from '@fishx/tracker';


interface FCAnchorProps extends React.FC<AnchorProps> {
  Link: typeof AnchorLink;
}
export const Anchor: FCAnchorProps = (props) => {
  return <AntdAnchor {...props} />;
}
Anchor.Link = AnchorLink;
Anchor.displayName = 'Anchor';
export default withError(Anchor);


// WEBPACK FOOTER //
// ./src/components/anchor/index.tsx